import { useEffect, useState } from 'react'
import { cn } from '@/lib/cn'
import { ArrowDown } from 'lucide-react'

/**
 * Scroll cue pinned to the bottom-center of the viewport while the visitor is
 * near the top of the page, per Website Review V2 ("at the bottom of the
 * website rather than at the bottom of this section"). Fades out once they
 * start scrolling so it never overlaps later content.
 */
export function ScrollCue() {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY < 120)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <a
      href="#challenge"
      aria-label="Scroll down to the case for longevity"
      data-floating-control
      tabIndex={visible ? 0 : -1}
      className={cn(
        'fixed bottom-5 left-1/2 z-30 hidden -translate-x-1/2 transition-opacity duration-300 lg:flex',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      {/* Blue to match the scroll-to-top button (Website Review V3) */}
      <span className="flex h-12 w-12 animate-nudge items-center justify-center rounded-full bg-brand-strong text-white shadow-lg transition-colors hover:bg-ink-deep">
        <ArrowDown className="h-5 w-5" aria-hidden />
      </span>
    </a>
  )
}
